import { render, staticRenderFns } from "./PermissionDeniedModal.vue?vue&type=template&id=634a0eeb"
import script from "./PermissionDeniedModal.vue?vue&type=script&lang=ts"
export * from "./PermissionDeniedModal.vue?vue&type=script&lang=ts"
import style0 from "./PermissionDeniedModal.vue?vue&type=style&index=0&id=634a0eeb&prod&lang=scss&module=styles"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports